module.exports = __webpack_public_path__ + "static/media/sobre-bg.cc3e9162.png";